module.exports = __webpack_public_path__ + "img/corporateCulture2.36799972.png";